import i18n from '@/plugins/i18n'
import ghs01 from '@/assets/img/hazard-pictograms/ghs01.png'
import ghs02 from '@/assets/img/hazard-pictograms/ghs02.png'
import ghs03 from '@/assets/img/hazard-pictograms/ghs03.png'
import ghs04 from '@/assets/img/hazard-pictograms/ghs04.png'
import ghs05 from '@/assets/img/hazard-pictograms/ghs05.png'
import ghs06 from '@/assets/img/hazard-pictograms/ghs06.png'
import ghs07 from '@/assets/img/hazard-pictograms/ghs07.png'
import ghs08 from '@/assets/img/hazard-pictograms/ghs08.png'
import ghs09 from '@/assets/img/hazard-pictograms/ghs09.png'
import { DataObjectData, DataPointLocation } from '@coac-gmbh/saifty-main-apis'

export interface PDFSelectionExtracted {
  location: DataPointLocation
  text: string
}

export interface PDFToolDataPointLocation extends DataPointLocation {
  title?: string
}

export interface SAIFTY_CHECK {
  name?: string
  calculationKey?: string
  notesKey: string
  statusKey: string
}

export const CANONICAL_VERSION = 'SEC_0_1.VERSION'
export const CANONICAL_REVISION_DATE = 'SEC_0_1.REV_DATE'
export const CANONICAL_SUBMITTED_DATE = 'SEC_0_1.SUBMITTED_DATE'
export const CANONICAL_LANGUAGE = 'SEC_0_1.LANGUAGE'
export const CANONICAL_NAME = 'SEC_1_1.NAME'
export const CANONICAL_PRODUCT_NUMBER = 'SEC_1_1.NUMBER'
export const CANONICAL_MANUFACTURER = 'SEC_1_3.MANUFACTURER'
export const CANONICAL_SYNONYMS = 'SEC_1_1.SYNONYMS'

export const ACTIVITIES_METADATA_ATTRIBUTES = {
  name: CANONICAL_NAME,
  manufacturer: CANONICAL_MANUFACTURER,
}
export const APPROVALS_METADATA_ATTRIBUTES = {
  version: CANONICAL_VERSION,
  articleNumber: CANONICAL_PRODUCT_NUMBER,
  revisionDate: CANONICAL_REVISION_DATE,
  ...ACTIVITIES_METADATA_ATTRIBUTES,
}
export const ACTIVITIES_INCLUDE_METADATA_ATTRIBUTES = Object.values(ACTIVITIES_METADATA_ATTRIBUTES)
export const APPROVALS_INCLUDE_METADATA_ATTRIBUTES = Object.values(APPROVALS_METADATA_ATTRIBUTES)

// If the item have not translation, we return empty to use the translation by canonical
// We don't want to add the canonicals translations to avoid side effects in the passport list
export const APPROVAL_METADATA_ATTRIBUTES_FOR_MATERIAL = [
  // eslint-disable-next-line
  // @ts-ignore
  { fieldName: CANONICAL_VERSION, translation: i18n.global.t('Version') },
  { fieldName: CANONICAL_REVISION_DATE, translation: i18n.global.t('Revision Date') },
  { fieldName: CANONICAL_SUBMITTED_DATE, translation: i18n.global.t('Submitted') },
  { fieldName: CANONICAL_LANGUAGE, translation: i18n.global.t('Language') },
  { fieldName: CANONICAL_NAME },
  { fieldName: CANONICAL_MANUFACTURER },
  { fieldName: CANONICAL_PRODUCT_NUMBER },
  { fieldName: CANONICAL_SYNONYMS },
]

export const COMPUTED_SAIFTY_CHECKS_KEYWORD = 'SAIFTY_CHECK'

export const ECHA_PREFIX = 'ECHA_'

export const PICTOGRAM_ICON_ITEM_NAME = 'SYMBOL'

export const IDENTIFIERS_CANONICAL_PREFIX = 'IDENTIFIERS'

export const IDENTIFIER_SUFFIX_OPTIONS = [
  { name: 'CAS', value: 'CAS' },
  { name: 'Name', value: 'NAME' },
  { name: 'Index', value: 'INDEX' },
]

export const PICTOGRAMS_ICON_OPTIONS = [
  { id: 'GHS01', src: ghs01 },
  { id: 'GHS02', src: ghs02 },
  { id: 'GHS03', src: ghs03 },
  { id: 'GHS04', src: ghs04 },
  { id: 'GHS05', src: ghs05 },
  { id: 'GHS06', src: ghs06 },
  { id: 'GHS07', src: ghs07 },
  { id: 'GHS08', src: ghs08 },
  { id: 'GHS09', src: ghs09 },
]

export interface RelatedItemsColumn {
  name: string
  canonicalPreffix: string
  colClasses: string
}

export interface ApprovalItemsGroup {
  name: string
  groupNumber: number
  items: DataObjectData[]
  itemsFilterless: DataObjectData[]
}

export interface ControlsForCreatingRelatedItems {
  isCreating: boolean
  canonicalItemName: string
}
export const SAIFTY_STATUS_SUFFIX = 'CHECK_STATUS'

export const SAIFTY_NOTES_SUFFIX = 'CHECK_NOTES'

export const DEFAULT_ITEMS_GROUP = 'Default'

export const COMPOSITION_KEY = 'COMPOSITION'

export const COMPOSITION_HEADER_KEY = 'COMPOSITION_HEADER'

export const COMPOSITION_COMPONENT_KEY = 'COMPOSITION_COMPONENT'

export const COMPOSITION_CAS_NUMBER_KEY = 'COMPOSITION_CAS'

export const COMPOSITION_CLASSIFICATION_KEY = 'COMPOSITION_CLASSIFICATION'

export const COMPOSITION_CONCENTRATION_KEY = 'COMPOSITION_CONCENTRATION'

export const COMPOSITION_AVERAGE_CONCENTRATION_KEY = 'COMPOSITION_AVERAGE_CONCENTRATION'

export const COMPOSITION_EG_NUMBER_KEY = 'COMPOSITION_EG_NR'

export const COMPOSITION_INDEX_NR_KEY = 'COMPOSITION_INDEX_NR'

export const COMPOSITION_COMPONENT_TYPE_KEY = 'COMPOSITION_COMPONENT_TYPE'

export const COMPOSITION_RECORD_NO_KEY = 'COMPOSITION_RECORD_NO'

export const COMPOSITION_UNIT_OF_MEASURE_KEY = 'COMPOSITION_UNIT_OF_MEASURE'

export const COMPOSITION_SUFFIXES_LIST = [
  COMPOSITION_COMPONENT_KEY,
  COMPOSITION_CAS_NUMBER_KEY,
  COMPOSITION_CLASSIFICATION_KEY,
  COMPOSITION_CONCENTRATION_KEY,
  COMPOSITION_AVERAGE_CONCENTRATION_KEY,
  COMPOSITION_EG_NUMBER_KEY,
  COMPOSITION_INDEX_NR_KEY,
  COMPOSITION_COMPONENT_TYPE_KEY,
  COMPOSITION_RECORD_NO_KEY,
  COMPOSITION_UNIT_OF_MEASURE_KEY,
]

export const COMPOSITION_CANONICAL_SECTION_PREFIX = 'SEC_3_2_6'

export const COMPOSITION_CANONICAL_NAME = `${COMPOSITION_CANONICAL_SECTION_PREFIX}.${COMPOSITION_KEY}`

export const COMPOSITION_CONCENTRATION_FULL_CANONICAL_NAME = `${COMPOSITION_CANONICAL_SECTION_PREFIX}.${COMPOSITION_CONCENTRATION_KEY}`

export const APPROVAL_COMPOSITION_COLUMNS: RelatedItemsColumn[] = [
  {
    name: '',
    canonicalPreffix: COMPOSITION_HEADER_KEY,
    colClasses: 'col-2',
  },
  {
    // eslint-disable-next-line
    // @ts-ignore
    name: i18n.global.t('Name'),
    canonicalPreffix: COMPOSITION_COMPONENT_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('CAS-No'),
    canonicalPreffix: COMPOSITION_CAS_NUMBER_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Classification'),
    canonicalPreffix: COMPOSITION_CLASSIFICATION_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Concentration'),
    canonicalPreffix: COMPOSITION_CONCENTRATION_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Average Concentration'),
    canonicalPreffix: COMPOSITION_AVERAGE_CONCENTRATION_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('EG No.'),
    canonicalPreffix: COMPOSITION_EG_NUMBER_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Index Nr.'),
    canonicalPreffix: COMPOSITION_INDEX_NR_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Component Type'),
    canonicalPreffix: COMPOSITION_COMPONENT_TYPE_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Record No'),
    canonicalPreffix: COMPOSITION_RECORD_NO_KEY,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Unit of measure'),
    canonicalPreffix: COMPOSITION_UNIT_OF_MEASURE_KEY,
    colClasses: 'col-2',
  },
]

export const MANDATORY_COMPOSITION_CANONICALS_TO_MIGRATE = [
  COMPOSITION_COMPONENT_KEY,
  COMPOSITION_CAS_NUMBER_KEY,
  COMPOSITION_CLASSIFICATION_KEY,
  COMPOSITION_CONCENTRATION_KEY,
  COMPOSITION_COMPONENT_TYPE_KEY,
  COMPOSITION_AVERAGE_CONCENTRATION_KEY,
  COMPOSITION_RECORD_NO_KEY,
  COMPOSITION_UNIT_OF_MEASURE_KEY,
]

export enum ClassificationCanonicalsSuffixesEnum {
  HeaderKey = 'CLASSIFICATION_HEADER',
  HCode = 'CLASSIFICATION_HCODE',
  HazardStatement = 'CLASSIFICATION_HAZARDSTATEMENTS',
  HazardClass = 'CLASSIFICATION_HAZARDCLASS',
  Category = 'CLASSIFICATION_CATEGORY',
  AddInfo = 'CLASSIFICATION_ADD_INFO',
  Organ = 'CLASSIFICATION_ORGAN',
  RouteOfExposure = 'CLASSIFICATION_ROUT_OF_EXPOSURE',
  Remark = 'CLASSIFICATION_REMARK',
  RegulatoryBase = 'CLASSIFICATION_REG_BASE',
  RegulatoryList = 'CLASSIFICATION_REG_LIST',
}

export const CLASSIFICATION_SUFFIXES_LIST = Object.values(ClassificationCanonicalsSuffixesEnum).map((i) => i)

export const CLASSIFICATION_CANONICAL_SECTION_PREFIX = 'SEC_2_1'

export const APPROVAL_CLASSIFICATION_COLUMNS: RelatedItemsColumn[] = [
  {
    name: '',
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.HeaderKey,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Hazard class'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.HazardClass,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Category'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.Category,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Additional information'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.AddInfo,
    colClasses: 'col-2',
  },
  {
    name: i18n.global.t('Organ'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.Organ,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Route of exposure'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.RouteOfExposure,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Remark'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.Remark,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Hazard statements'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.HazardStatement,
    colClasses: 'col-2',
  },
  {
    name: 'HCODE',
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.HCode,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Regulatory Base'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.RegulatoryBase,
    colClasses: 'col-1',
  },
  {
    name: i18n.global.t('Regulatory List'),
    canonicalPreffix: ClassificationCanonicalsSuffixesEnum.RegulatoryList,
    colClasses: 'col-1',
  },
]

export const AI_DOCUMENT_EXTRACTION_PERFORMANCE_PERCENTAGE = 90

// This function allow us to apply certain business rules to improve the extraction KPI, then, the function changes the value using the 'change by reference' logic
export function applyAIRulesToTheConfidenceField(isItemValidated: boolean, item: DataObjectData, cardValue: string) {
  if (window.ENV.APPLY_BUSINESS_RULES_TO_CONFIDENCE_FIELD && !isItemValidated) {
    if (item.fieldValue !== cardValue) {
      item.confidence = 0
    }
    if (
      item.fieldValue === cardValue &&
      typeof item.confidence === 'number' &&
      item.confidence < AI_DOCUMENT_EXTRACTION_PERFORMANCE_PERCENTAGE
    ) {
      item.confidence = 95
    }
  }
}

export const APPROVAL_CLASSIFICATION_CANONICAL_LIST = APPROVAL_CLASSIFICATION_COLUMNS.map(
  (classificationItem) => CLASSIFICATION_CANONICAL_SECTION_PREFIX + '.' + classificationItem.canonicalPreffix,
)

export const APPROVAL_COMPOSITION_CANONICAL_LIST = APPROVAL_COMPOSITION_COLUMNS.map(
  (compositionItem) => COMPOSITION_CANONICAL_SECTION_PREFIX + '.' + compositionItem.canonicalPreffix,
)

export const RELATED_CANONICAL_ITEMS = [
  ...APPROVAL_CLASSIFICATION_CANONICAL_LIST,
  ...APPROVAL_COMPOSITION_CANONICAL_LIST,
]
